module.exports = __webpack_public_path__ + "static/media/HHFH.9a75fb85.svg";